type TodayTask={id:string;status:string;due_at:string|null;personal?:{inbox?:number;focus_at?:string|null}};
/** Today includes open tasks that require attention on or before this day. */
export function todayTasks<T extends TodayTask>(tasks:readonly T[],day:string){
 const open=tasks.filter(task=>!['completed','archived'].includes(task.status));
 const escalations=open.filter(task=>task.due_at&&task.due_at<=day).sort((a,b)=>a.due_at!.localeCompare(b.due_at!)||a.id.localeCompare(b.id));
 const reserved=new Set(escalations.map(task=>task.id));
 const focused=open.filter(task=>!reserved.has(task.id)&&task.personal?.focus_at&&task.personal.focus_at<=day);
 return {escalations,focused};
}
